import { render, staticRenderFns } from "./attached-create.vue?vue&type=template&id=24bc6f44&scoped=true"
import script from "./attached-create.vue?vue&type=script&lang=js"
export * from "./attached-create.vue?vue&type=script&lang=js"
import style0 from "./attached-create.vue?vue&type=style&index=0&id=24bc6f44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bc6f44",
  null
  
)

export default component.exports